import { Component, OnInit, TemplateRef, ViewContainerRef } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzTableFilterList, NzTableQueryParams, NzTableSortOrder } from 'ng-zorro-antd/table'
import { FilterObj, QueryTable } from 'src/app/services/interface/general.model'
import { TicketingService } from 'src/app/services/ticketing.service'
import { AddVendorComponent } from './add-vendor/add-vendor.component'
import { ViewVendorComponent } from './view-vendor/view-vendor.component'

interface ColumnItem {
  name: string
  key: string
  sortOrder: NzTableSortOrder | null
  sortFn: null | boolean
  listOfFilter: NzTableFilterList
  filterFn: null
  left: boolean
  right: boolean
}

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss'],
})
export class VendorComponent implements OnInit {
  form: FormGroup

  isLoading: boolean = true
  totalData: number = 0
  pageSize: number = 25
  pageIndex: number = 1

  constructor(
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef,
    private ticketService: TicketingService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
  ) {
    this.form = this.fb.group({
      keyword: [null, Validators.compose([Validators.required])],
      prefix: ['vendor', Validators.compose([Validators.required])],
    })
  }

  ngOnInit(): void {}

  listOfColumns: ColumnItem[] = [
    {
      name: 'Action',
      key: 'action',
      sortOrder: null,
      sortFn: null,
      listOfFilter: [],
      filterFn: null,
      left: true,
      right: false,
    },
    {
      name: 'Code',
      key: 'code',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
    },
    {
      name: 'Name',
      key: 'name',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
    },
    {
      name: 'Created By',
      key: 'createdBy',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
    },
    {
      name: 'Updated By',
      key: 'updatedBy',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
    },
    {
      name: 'Status',
      key: 'status',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: true,
    },
  ]

  queryTable: QueryTable = {
    sort: null,
    filters: [],
    pageSize: this.pageSize,
    pageIndex: this.pageIndex - 1,
  }

  listOfData = []

  fetchVendor() {
    this.isLoading = true
    this.ticketService.getVendor(this.queryTable).subscribe((r: any) => {
      this.isLoading = false
      this.listOfData = r.rows
      this.totalData = r.count
    })
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort, filter } = params
    this.queryTable.pageSize = pageSize
    this.queryTable.pageIndex = pageIndex - 1
    const currentSort = sort.find(item => item.value !== null)
    const sortField = (currentSort && currentSort.key) || null
    const sortOrder = (currentSort && currentSort.value) || null

    if (sortField != null && sortOrder != null) {
      this.queryTable.sort = {
        field: sortField,
        order: sortOrder,
      }
    } else {
      this.queryTable.sort = null
    }
    this.fetchVendor()
  }

  trackByName(_: number, item: ColumnItem): string {
    return item.name
  }

  reset() {
    this.form.reset()
    this.form.patchValue({ prefix: 'name' })
    this.queryTable.sort = null
    this.queryTable.filters = []
    this.listOfColumns.forEach(r => {
      r.sortOrder = null
    })
    this.fetchVendor()
  }

  search() {
    if (this.form.value.keyword?.length > 0) {
      this.queryTable.filters = [
        {
          field: this.form.value.prefix,
          keyword: this.form.value.keyword,
        },
      ]
    } else {
      this.queryTable.filters = []
    }
    this.fetchVendor()
  }

  createVendor(tplFooter: TemplateRef<{}>) {
    // console.log(tplFooter)
    const modal = this.modal.create({
      nzTitle: 'Add Vendor',
      nzContent: AddVendorComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {},
      nzMaskClosable: false,
      nzClosable: false,
      nzFooter: tplFooter,
    })
    modal.afterClose.subscribe(() => {
      this.fetchVendor()
    })
  }

  updateVendor(data, tplFooter: TemplateRef<{}>) {
    // console.log(tplFooter)
    const modal = this.modal.create({
      nzTitle: 'View Vendor',
      nzContent: ViewVendorComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {
        data: data,
      },
      nzMaskClosable: false,
      nzClosable: false,
      nzFooter: tplFooter,
    })
    modal.afterClose.subscribe(() => {
      this.fetchVendor()
    })
  }
  deleteVendor(code: string) {
    const modal = this.modal.confirm({
      nzTitle: 'Are you sure delete this task?',
      nzContent: '<b style="color: red;">This action cannot be undo</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => {
        this.ticketService.deleteVendor(code).subscribe(
          r => {
            this.notification.success('Success', r.message)
            this.fetchVendor()
          },
          err => {
            this.notification.error('Error', err.error.message)
            this.fetchVendor()
          },
        )
      },
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel'),
    })
  }
}
